'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }



var _module = _angular2.default.module('cb.core.search.cb-search-form-v2', []);

_module.directive('cbSearchFormV2', cbSearchFormV2Directive);

exports.default = _module;


function cbSearchFormV2Directive() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'searchFormV2',
        controller: 'cbSearchFormV2Controller',
        template: "<div class=\"sc-input__position\">\r\n    <input class=\"input input-text input-text__input sc-input--enterfunctie sc-text__input\"  type=\"search\" name=\"q\" placeholder=\"Zoekwoord\" data-ng-model=\"searchFormV2.searchInput\">\r\n    <label class=\"input-text__label label\">Waar bent u naar op zoek?</label>\r\n    <a ng-href=\"{{searchFormV2.searchUrl}}{{searchFormV2.searchInput || ''}}\"><button type=\"button\" class=\"btn btn--primary-blue sc-btn\"><span class=\"icon icon--search sc-icon\"></span></button></a>\r\n</div>\r\n"
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/search-v2/cb-search-form-v2.directive.js
// module id = 816
// module chunks = 0